import React, { Fragment } from "react";
import ReactPlayer from "react-player";
import {
  YOUTUBE_URL,
  IMAGE_UPLOAD,
  VIDEO_UPLOAD,
  PDF_UPLOAD,
} from "../../Constants/types";
import { getYoutubeId } from "../../Utils/utils";
const pdfIcon = require("../../assets/media/pdf.png");
const unknownIcon = require("../../assets/media/unknown.png");
const getComponent = (content, onClickAttachment) => {
  if (content) {
    const { media_type, media_url } = content;
    if (media_type === PDF_UPLOAD) {
      return onClickAttachment ? (
        <div
          style={{ backgroundImage: `url(${pdfIcon})`, cursor: "pointer" }}
          className="upload-item"
          data-toggle="modal"
          data-target="#view_pdf_dialog"
          onClick={() => onClickAttachment(content)}
        />
      ) : (
        <div
          style={{ backgroundImage: `url(${pdfIcon})`, cursor: "pointer" }}
          className="upload-item"
        />
      );
    }
    if (media_type === IMAGE_UPLOAD) {
      return (
        <div
          style={{ backgroundImage: `url(${media_url})` }}
          className="upload-item"
        ></div>
      );
    }
    if (media_type === VIDEO_UPLOAD) {
      return (
        <div className="upload-item">
          <ReactPlayer
            url={media_url}
            width="100%"
            height="100%"
            controls={true}
          />
        </div>
      );
    }
    if (media_type === YOUTUBE_URL) {
      return (
        <div className="upload-item">
          <iframe
            title="video"
            width="100%"
            height="100%"
            src={`//www.youtube.com/embed/${getYoutubeId(
              media_url
            )}?modestbranding=1&showinfo=0`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      );
    }
  } else {
    return (
      <div className="upload-item">
        <img src={unknownIcon} alt="" />
      </div>
    );
  }
};

const UploadPanel = ({ contents, readOnly, onClickAttachment }) => {
  return (
    <div className="upload-panel">
      {readOnly
        ? contents.map((item) => getComponent(item, onClickAttachment))
        : [0, 1, 2, 3, 4, 5].map((item) => (
            <Fragment key={item}>{getComponent(contents[item])}</Fragment>
          ))}
    </div>
  );
};
export default UploadPanel;



// WEBPACK FOOTER //
// ./src/components/AddNoteModal/UploadPanel.js